import { useTranslation } from 'react-i18next'
import { Autocomplete, Box, TextField } from '@mui/material'
import { useAxios } from '../../hooks/useAxios'
import { useState } from 'react'
import { DeviceSpec } from '../../types/models'
import { sorter } from '../../utils/sorter'
import { DeviceSpecCard } from '../DeviceSpecCard'

export interface DeviceSpecSelectorProps {
  spec: DeviceSpec | null
  onChange: (spec: DeviceSpec | null) => void
}

export function DeviceSpecSelector(props: DeviceSpecSelectorProps): React.ReactElement {

  const { spec, onChange } = props
  const [specs, setSpecs] = useState<DeviceSpec[]>([])

  const { t } = useTranslation()

  useAxios<DeviceSpec[]>({
    url: '/device-specs',
    onSuccess: data => setSpecs(sorter(data, 'manufacturer', 'model'))
  })

  return (
    <Box data-cy="button-Select device spec" sx={{ pt: 2 }}>
      <div>
        <Autocomplete
          id="select-device-spec"
          disablePortal
          options={specs}
          getOptionLabel={(option) => `${option.manufacturer} ${option.model}`}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderOption={(props, option) => (
            <Box data-cy={`box-${option.manufacturer} ${option.model}`} component="li" {...props}>
              {option.manufacturer} {option.model}
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('Select Device Specification')}
              inputProps={{
                ...params.inputProps,
                autoComplete: 'off'
              }}
            />
          )}
          onChange={(_, value) => onChange(value)}
        />
      </div>

      <DeviceSpecCard spec={spec}/>
    </Box>
  )
}
